import { render, staticRenderFns } from "./TcoBlock.vue?vue&type=template&id=6023f683&scoped=true"
import script from "./TcoBlock.vue?vue&type=script&lang=js"
export * from "./TcoBlock.vue?vue&type=script&lang=js"
import style0 from "./TcoBlock.vue?vue&type=style&index=0&id=6023f683&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6023f683",
  null
  
)

export default component.exports